module.exports = __webpack_public_path__ + "static/media/Simon_Lycett_getty_mobile.17b041b3.jpg";